export const getSelectedLineNumber = state => state.productDetails.productId;

export const getRecommendedProducts = state => state.productDetails.recommendations;
